import { render, staticRenderFns } from "./comment_editor.vue?vue&type=template&id=c8e4eed6&scoped=true"
import script from "./comment_editor.vue?vue&type=script&lang=js"
export * from "./comment_editor.vue?vue&type=script&lang=js"
import style0 from "./comment_editor.vue?vue&type=style&index=0&id=c8e4eed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e4eed6",
  null
  
)

export default component.exports